import React from 'react';
import '../App.css';

interface props {
    placeholder: string,
    callback: (val: string) => void
}

function Input({placeholder, callback}: props) {
    return (
        <input className="email-input" placeholder={placeholder} onChange={(e) => callback(e.target.value)}/>
    );
}

export default Input;
